import React from 'react';
import { Row } from 'react-bootstrap';
import {
  buildWhereForDates,
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldDateRanger,
  FieldSelectIsActive,
  TableEditButtons,
  FormCol3,
  FieldSelectYesNo,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import {
  FieldSelectCollector,
  FieldSelectMaterialGroup,
  FormFieldMultiMaterialDlg,
} from 'shared-pages';
import { useRootStore } from 'store';
import { FieldSelectDocOptions } from 'shared-pages/components/select-dlg/fs-adr';
import { DocFilter } from 'shared-pages/common/constants';
import { buildWhereFromDocFilter } from 'shared-pages/common/filters-helpfunc';
import { first } from 'lodash';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    console.log('values', values);
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [{ firstName: likeObj }, { lastName: likeObj }, { name: likeObj }],
      };
    }
    if (values.collectionpointId) {
      where = { ...where, collectionpointId: values.collectionpointId };
    }
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
  }
  console.log('where', where);
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false, isGridInForm }) => {
  //
  const { appStore } = useRootStore();
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση')}
          type="search"
          disable={disable}
        />
        {/* {!isGridInForm && (
          <FieldSelectCollector as={FormCol} name="collectorId" label={t('Συλλέκτης')} />
        )}
        <FieldSelectDocOptions withBlank={false} label={t('ADR')} name="adr" as={FormCol} />
        <FieldSelectYesNo label={t('Εγκεκριμένοι')} disable={disable} name="isApproved" />
        <FieldSelectIsActive label={t('Ενεργές Εγγραφές')} disable={disable} /> */}
      </Row>
    </FormFilterCard>
  );
};

